import {
  createGeocodeCachedModel,
  IGeocodeCachedRequestSchema,
} from '@cian/api-models/monolith-csharp/api/geo/geocode-cached';
import { getHttpApi } from '@cian/http-api/browser';

export async function getCachedGeocode(parameters: IGeocodeCachedRequestSchema, subdomain?: string) {
  try {
    const httpApi = getHttpApi();
    const { response, statusCode } = await httpApi.fetch(createGeocodeCachedModel({ parameters }), {
      subdomain: subdomain || 'www',
    });

    if ('errors' in response || statusCode !== 200) {
      throw response;
    }

    return response;
  } catch (error) {
    throw error;
  }
}
